import React, { useEffect, useState } from "react";
import {
  getFormContentPreview,
} from "../../../../api/services/services";
import { Grid, Button, Snackbar, Typography, Box } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import Input from "../../../atoms/Input";
import ContactDetailField from "../../../molecules/ContactDetailField";
import { useLocation } from "react-router-dom";
import PremiumPublicLayout from "../../../templates/PremiumPublicLayout";
import PremiumCard from "../../../molecules/PremiumCard";
import SectionHeader from "../../../molecules/SectionHeader";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import DescriptionIcon from "@mui/icons-material/Description";
import CommentIcon from "@mui/icons-material/Comment";
import PrintComponent from "../../PrintComponent";
import ShippingInstructionsDownload from "./download";
import TextArea from "../../../atoms/Textarea";
import moment from "moment";

const ShippingInstructionsClientSide = () => {
  const [surveyData, setSurveyData] = useState(null);
  const [formContent, setFormContent] = useState({});

  const [formContentId, setFormContentId] = useState("");
  const [isEdit, setIsEdit] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const urlData = new URLSearchParams(location.search);
  const email = urlData.get("email");
  const surveyId = urlData.get("surveyId");
  const formId = urlData.get("formId");
  const token = urlData.get("token");

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const [isValid, setIsValid] = useState(false);

  //
  const getContent = () => {
    setIsLoading(true);
    getFormContentPreview(surveyId, formId, email, token)
      .then((res) => {
        setIsValid(true);
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setIsLoading(false);
      });
  };

  useEffect(() => {
    getContent();
  }, []);

  return (
    <>
      {isValid ? (
        <PremiumPublicLayout
          title="Shipping Instructions"
          hideBackButton={true}
          actions={
            <Box sx={{ display: 'flex', gap: 2 }}>
              {!isEdit && (
                <Button
                  variant="contained"
                  onClick={() => {
                    if (window.innerWidth <= 768) { if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") { setSnackbarMessage("For a good experience, please use a desktop screen"); setOpenSnackbar(true); } else { alert("For a good experience, please use a desktop screen"); } return; }
                      setIsLoading(true);
                    var tempTitle = document.title;
                    document.title = `Shipping-Instructions-${
                      formContent?.customerName
                    }-${moment(new Date()).format("DD.MM.YYYY")}`;
                    window.print();
                    document.title = tempTitle;
                    setIsLoading(false);
                  }}
                  disabled={isLoading}
                  sx={{ 
                    textTransform: "none", 
                    borderRadius: "var(--radius-md)", 
                    padding: "10px 24px",
                    fontWeight: 700,
                    backgroundColor: "var(--text-main)",
                    boxShadow: "0 4px 12px rgba(15, 23, 42, 0.2)",
                    '&:hover': { backgroundColor: '#000' }
                  }}
                  startIcon={<DescriptionIcon />}
                >
                  Save as PDF
                </Button>
              )}
            </Box>
          }
        >
          {/* Details Section */}
          <SectionHeader title="Shipment Details" icon={<LocalShippingIcon />} />
          <PremiumCard sx={{ marginBottom: "32px" }}>
             <Grid container spacing={3} sx={{ mb: 4 }}>
                <Grid item xs={12} md={6}>
                    <ContactDetailField
                      label="Mode of Shipment"
                      isEdit={isEdit}
                      type="text"
                      value={formContent?.airShipment}
                      onChange={(e) => {
                          let values = { ...formContent };
                          values.airShipment = e.target.value;
                          setFormContent(values);
                      }}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <ContactDetailField
                      label="Date"
                      isEdit={isEdit}
                      type="date"
                      value={formContent?.date}
                      onChange={(e) => {
                          let values = { ...formContent };
                          values.date = e.target.value;
                          setFormContent(values);
                      }}
                    />
                </Grid>
            </Grid>


            <Grid container spacing={3}>
                <Grid item xs={12}>
                     {/* Shipper */}
                     <label className="mb-1 d-block fw-bold text-secondary">Shipper</label>
                     {isEdit ? (
                        <Input
                        id={"shipper"}
                        type="text"
                        style="full-border-field"
                        value={formContent?.shipper}
                        onChange={(e) => {
                            let values = { ...formContent };
                            values.shipper = e.target.value;
                            setFormContent(values);
                        }}
                        inline={{ width: "100%" }}
                        />
                    ) : (
                        <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                            {formContent?.shipper || "-"}
                        </Typography>
                    )}
                </Grid>
                <Grid item xs={12}>
                    {/* Consignee */}
                    <label className="mb-1 d-block fw-bold text-secondary">Consignee</label>
                     {isEdit ? (
                        <Input
                        id={"consignee"}
                        type="text"
                        style="full-border-field"
                        value={formContent?.consignee}
                        onChange={(e) => {
                            let values = { ...formContent };
                            values.consignee = e.target.value;
                            setFormContent(values);
                        }}
                        inline={{ width: "100%" }}
                        />
                    ) : (
                         <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                            {formContent?.consignee || "-"}
                        </Typography>
                    )}
                </Grid>
                <Grid item xs={12}>
                     {/* Notify */}
                     <label className="mb-1 d-block fw-bold text-secondary">Notify</label>
                      {isEdit ? (
                        <Input
                        id={"notify"}
                        type="text"
                        style="full-border-field"
                        value={formContent?.notify}
                        onChange={(e) => {
                            let values = { ...formContent };
                            values.notify = e.target.value;
                            setFormContent(values);
                        }}
                        inline={{ width: "100%" }}
                        />
                    ) : (
                         <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                            {formContent?.notify || "-"}
                        </Typography>
                    )}
                </Grid>
                 <Grid item xs={12}>
                     {/* Description */}
                     <label className="mb-1 d-block fw-bold text-secondary">Description</label>
                      {isEdit ? (
                        <Input
                        id={"description"}
                        type="text"
                        style="full-border-field"
                        value={formContent?.description}
                        onChange={(e) => {
                            let values = { ...formContent };
                            values.description = e.target.value;
                            setFormContent(values);
                        }}
                        inline={{ width: "100%" }}
                        />
                    ) : (
                         <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                           {formContent?.description || "-"}
                        </Typography>
                    )}
                </Grid>
                 <Grid item xs={12} md={6}>
                    {/* Volume/Gross Weight */}
                     <label className="mb-1 d-block fw-bold text-secondary">Volume/Gross Weight</label>
                      {isEdit ? (
                        <Input
                        id={"gross-weight"}
                        type="text"
                        style="full-border-field"
                        value={formContent?.grossWeight}
                        onChange={(e) => {
                            let values = { ...formContent };
                            values.grossWeight = e.target.value;
                            setFormContent(values);
                        }}
                        inline={{ width: "100%" }}
                        />
                    ) : (
                         <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                            {formContent?.grossWeight || "-"}
                        </Typography>
                    )}
                 </Grid>
                 <Grid item xs={12} md={6}>
                     {/* Port of Discharge */}
                      <label className="mb-1 d-block fw-bold text-secondary">Port of Discharge</label>
                      {isEdit ? (
                        <Input
                        id={"port-of-discharge"}
                        type="text"
                        style="full-border-field"
                        value={formContent?.portOfDischarge}
                        onChange={(e) => {
                            let values = { ...formContent };
                            values.portOfDischarge = e.target.value;
                            setFormContent(values);
                        }}
                        inline={{ width: "100%" }}
                        />
                    ) : (
                         <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                            {formContent?.portOfDischarge || "-"}
                        </Typography>
                    )}
                 </Grid>
                  <Grid item xs={12} md={6}>
                     {/* Destination Country */}
                      <label className="mb-1 d-block fw-bold text-secondary">Destination Country</label>
                      {isEdit ? (
                        <Input
                        id={"country"}
                        type="text"
                        style="full-border-field"
                        value={formContent?.destinationCountry}
                        onChange={(e) => {
                            let values = { ...formContent };
                            values.destinationCountry = e.target.value;
                            setFormContent(values);
                        }}
                        inline={{ width: "100%" }}
                        />
                    ) : (
                         <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                            {formContent?.destinationCountry || "-"}
                        </Typography>
                    )}
                  </Grid>
            </Grid>
          </PremiumCard>

          <SectionHeader title="Remarks" icon={<CommentIcon />} />
          <PremiumCard>
               {/* Remarks */}
                 
                {isEdit ? (
                <TextArea
                    id={"remarks"}
                    type="text"
                    style="full-border-field bg-app"
                    value={formContent?.remarks}
                    onChange={(e) => {
                    let values = { ...formContent };
                    values.remarks = e.target.value;
                    setFormContent(values);
                    }}
                    inline={{ width: "100%" }}
                />
                ) : (
                    <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0', minHeight: '100px' }}>
                         {formContent?.remarks || "-"}
                    </Typography>
                )}
          </PremiumCard>
        </PremiumPublicLayout>
      ) : (
        <div className="no-print">
          {isLoading ? (
            <div> Loading...</div>
          ) : (
            <div> Ooops... Something went wrong...</div>
          )}
        </div>
      )}

      <PrintComponent>
        <ShippingInstructionsDownload
          surveyData={surveyData}
          formContent={formContent}
        />
      </PrintComponent>

      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000} // Adjust the duration as needed
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={
            snackbarMessage?.includes("successful") ? "success" : "error"
          }
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
      {/* /snackbar */}
    </>
  );
};
export default ShippingInstructionsClientSide;
